import React from 'react';
import { Box, Typography, Grid, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { contactOptionsSectionStyles } from '../styles';

// Custom Phone Icon Component with the new design
const CustomPhoneIcon = ({ sx }) => (
  <Box sx={{ ...sx, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <rect width="64" height="64" rx="8" fill="#E8F0FE"/>
      <g transform="translate(16, 15) scale(1)">
        <path d="M12.0879 15.5351L17.6113 21.3636C18.2102 21.9955 19.2947 22.0857 20.503 21.4903C23.5779 20.2155 24.601 19.9047 25.185 20.521L31.5343 27.2209C32.2848 28.0129 32.0845 29.3321 31.2452 30.2177C26.8873 34.8164 19.804 34.8164 15.446 30.2177L3.58535 17.7019C-0.750781 13.1263 -0.750781 5.72376 3.58535 1.14813C4.44233 0.243816 5.75839 0.0213093 6.53719 0.843127L12.8864 7.54306C13.4367 8.12377 13.1417 9.2054 11.9402 12.4281C11.3816 13.6861 11.4711 14.8842 12.0879 15.5351Z" fill="#1565D8"/>
      </g>
    </svg>
  </Box>
);

// Custom Email Icon Component with the new design
const CustomEmailIcon = ({ sx }) => (
  <Box sx={{ ...sx, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <rect width="64" height="64" rx="8" fill="#E8F0FE"/>
      <g opacity="1">
        <path fillRule="evenodd" clipRule="evenodd" d="M47.0933 23.2531V41.3339C47.0933 44.4822 44.5221 47.0934 41.3333 47.0934H22.9333C19.7445 47.0934 17.1333 44.4822 17.1333 41.3339V23.2531C17.1333 22.4022 17.5463 21.632 18.2397 21.1567L22.5175 17.9629C22.8978 17.6791 23.4156 17.7722 23.6994 18.1524C23.9832 18.5327 23.8901 19.0505 23.5098 19.3343L19.2321 22.5281C19.0009 22.6931 18.8598 22.9489 18.8533 23.2246C19.1175 23.1283 19.4045 23.0743 19.7333 23.0743C20.1853 23.0743 20.6237 23.1978 21.0084 23.4244L32.1333 31.1556L43.258 23.4244C43.9222 22.9467 44.7022 22.8936 45.3732 23.1531C45.3691 22.8773 45.2279 22.6213 44.9965 22.4563L40.8285 19.3548C40.4482 19.0709 40.3551 18.5531 40.6389 18.1729C40.9228 17.7926 41.4406 17.6995 41.8208 17.9833L45.9888 21.0848C46.6821 21.56 47.0933 22.3302 47.0933 23.1531V23.2531Z" fill="#1565D8"/>
        <path d="M39.3333 13.3334C41.6173 13.3334 43.3333 15.0493 43.3333 17.3334V25.3334L32.3333 32.5339L21.3333 25.3334V17.3334C21.3333 15.0493 23.0492 13.3334 25.3333 13.3334H39.3333ZM26.5336 24.5339C26.0597 24.5339 25.6736 24.9199 25.6736 25.3939C25.6736 25.8678 26.0597 26.2539 26.5336 26.2539H37.1331C37.607 26.2539 37.9931 25.8678 37.9931 25.3939C37.9931 24.9199 37.607 24.5339 37.1331 24.5339H26.5336ZM26.5336 19.7341C26.0597 19.7341 25.6736 20.1202 25.6736 20.5941C25.6737 21.0679 26.0598 21.4541 26.5336 21.4541H37.1331C37.6069 21.4541 37.9929 21.0679 37.9931 20.5941C37.9931 20.1202 37.607 19.7341 37.1331 19.7341H26.5336Z" fill="#7BB3F0"/>
      </g>
    </svg>
  </Box>
);

// Custom WhatsApp Icon Component with the new design
const CustomWhatsAppIcon = ({ sx }) => (
  <Box sx={{ ...sx, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <rect width="64" height="64" rx="8" fill="#E8F0FE"/>
      <g transform="translate(12, 12) scale(1.6)">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.5335 14.1905C17.6213 15.1907 23.1651 12.6073 27.0256 6.47501C27.045 6.44427 27.0627 6.41275 27.0787 6.38059C28.5644 8.05239 29.4669 10.2541 29.4669 12.6666V16.1333C29.4669 19.6369 27.5457 22.7867 24.5675 24.4275C24.1795 24.158 23.7081 24 23.1998 24C21.8743 24 20.7998 25.0745 20.7998 26.4C20.7998 27.7254 21.8743 28.7999 23.1998 28.7999C23.8711 28.7999 24.478 28.5244 24.9136 28.0801C24.2646 30.1189 22.3101 31.6 19.9998 31.6C17.1617 31.6 14.8605 29.3648 14.857 26.6063L15.6158 24.5257C12.5336 22.9146 10.5335 19.7081 10.5335 16.1333V14.1905ZM10.5523 12.0658C10.8622 7.11742 14.9737 3.19995 20.0002 3.19995C22.1187 3.19995 24.0747 3.89585 25.652 5.07152C25.6036 5.12137 25.5591 5.17785 25.5194 5.24077C22.045 10.7598 17.1342 13.0258 10.6453 12.0741C10.6141 12.0695 10.5831 12.0668 10.5523 12.0658ZM12.8808 27.6535C13.4035 31.0197 16.3917 33.6 19.9998 33.6C23.6087 33.6 26.5974 31.0186 27.1191 27.6514L30.9554 28.425C32.4793 28.7223 33.6935 29.8745 34.07 31.3808L35.1763 35.8059C35.3025 36.3108 34.9207 36.7999 34.4002 36.7999H5.6002C5.07974 36.7999 4.69786 36.3108 4.82408 35.8059L5.92893 31.3865C6.30642 29.8766 7.5255 28.7227 9.0462 28.4302L12.8808 27.6535Z" fill="#1565D8"/>
        <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M23.1999 27.2C23.6417 27.2 23.9999 26.8418 23.9999 26.4C23.9999 25.9581 23.6417 25.6 23.1999 25.6C22.7581 25.6 22.3999 25.9581 22.3999 26.4C22.3999 26.8418 22.7581 27.2 23.1999 27.2Z" fill="#7BB3F0"/>
        <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M30.9708 11.2H31.2001C32.5256 11.2 33.6001 12.2745 33.6001 13.6V16.8C33.6001 18.1254 32.5256 19.2 31.2001 19.2H30.6348C30.9177 18.2182 31.0671 17.1877 31.0671 16.1333V12.6666C31.0671 12.1694 31.0343 11.6798 30.9708 11.2Z" fill="#7BB3F0"/>
        <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M9.366 19.2H8.7999C7.47442 19.2 6.3999 18.1254 6.3999 16.8V13.6C6.3999 12.2745 7.47442 11.2 8.7999 11.2H9.02996C8.96642 11.6798 8.93363 12.1694 8.93363 12.6666V16.1333C8.93363 17.1877 9.08307 18.2182 9.366 19.2Z" fill="#7BB3F0"/>
      </g>
    </svg>
  </Box>
);

export const ContactOptions = () => {
  const { t } = useTranslation();

  const contactMethods = [
    {
      icon: <CustomPhoneIcon sx={contactOptionsSectionStyles.phoneIcon} />,
      title: t('ecommerce.support.contact.phone.title', 'Llamar'),
      description: t('ecommerce.support.contact.phone.description', 'Habla directamente con nuestro equipo'),
      contact: t('ecommerce.support.contact.phone.number', '(305) 821-4080'),
      action: 'tel:+13058214080'
    },
    {
      icon: <CustomEmailIcon sx={contactOptionsSectionStyles.emailIcon} />,
      title: t('ecommerce.support.contact.email.title', 'Email'),
      description: t('ecommerce.support.contact.email.description', 'Envíanos un correo electrónico'),
      contact: t('ecommerce.support.contact.email.address', 'quote@sylroofingsupply.com'),
      action: 'mailto:quote@sylroofingsupply.com'
    },
    {
      icon: <CustomWhatsAppIcon sx={contactOptionsSectionStyles.whatsappIcon} />,
      title: t('ecommerce.support.contact.whatsapp.title', 'WhatsApp'),
      description: t('ecommerce.support.contact.whatsapp.description', 'Chatea con nosotros directamente'),
      contact: t('ecommerce.support.contact.whatsapp.number', '+1 (321) 330-9934'),
      action: 'https://wa.me/13213309934'
    }
  ];

  return (
    <Box sx={contactOptionsSectionStyles.container}>
      <Grid container spacing={contactOptionsSectionStyles.grid.spacing}>
        {contactMethods.map((method, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box sx={contactOptionsSectionStyles.card}>
              {method.icon}
              <Typography variant="h6" sx={contactOptionsSectionStyles.title}>
                {method.title}
              </Typography>
              <Typography sx={contactOptionsSectionStyles.description}>
                {method.description}
              </Typography>
              <Link
                href={method.action}
                target={method.title === 'WhatsApp' ? '_blank' : undefined}
                rel={method.title === 'WhatsApp' ? 'noopener noreferrer' : undefined}
                sx={contactOptionsSectionStyles.contactInfo}
                underline="none"
              >
                {method.contact}
              </Link>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ContactOptions; 